export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: '703ca5ef-e86c-4faf-a32f-94ab73112e50',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'nuevamutuasanitaria.alares',

  /**
  * Nombre de la app
  */
  appName: 'Nueva Mutua Sanitaria',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-2LBC5ZPK1E',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: false,

  /** Registro habilitado o deshabilitado */
  registration: false,

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: false,

  recaptcha: '6Ld60XUUAAAAAEbbjQOjWi_T7L9R_gXszlcXPyLV',
  videoCallsUrl: 'https://videollamada.vivofacil.com/?kid=AljJRe39SLEsWhMFg2pqTrA',
    
  /**
   * Extensión en producción de URL de la app
   * (es, com, org...)
   */
   appUrlTld: 'es',

  /**
   * Nombre de marca interno (Alares, Vivofácil...)
   */
   brandName: 'Alares',
   
   /**
   * Mail transport (alares, vivofacil...)
   */
   mailTransport: 'alares'
};
